<template>
  <section class="start-screen-container">
    <div class="start-screen-content main-container">
      <transition name="fade-opacity-lazy">
        <div class="block-container" v-if="isVisible(0)">
          <big-title class="big-title-container"
                     :font-family="$isMobile
          ? 'EurostileR'
          : 'Eurostile'">
            {{ mainTitle }}
          </big-title>
          <main-title :font-family="'Verdana'"
                      class="main-paragraph-container"
                      :line-height="'big'"
                      :color="'purple-grey'">
            {{ mainParagraph }}
          </main-title>
        </div>
      </transition>
      <transition name="fade-opacity-lazy">
        <slider-banner v-if="isVisible(1) && !$isMobile"
                       :cards-info="cardsInfo">
          <template v-slot:card="{ item }">
            <card-banner :item="item"/>
          </template>
        </slider-banner>
      </transition>
        <main-button
            @click="IS_ACTIVE_MODAL(true)"
            :class="['animation-opacity', { 'is-active-opacity':  isVisible(1)}]"
            v-if="$isMobile">
          {{ btnText }}
        </main-button>
      <div class="bg-filter-mobile"></div>
    </div>
    <div class="bg-filter"></div>
    <div class="bg-container" :class="{'active' : !isLoading}">
        <video
            ref="videoBG" @loadeddata="load" class="video" loop playsinline preload="auto" autoplay  muted>
          <source :src="getUrl(`start.mp4`)" type="video/mp4"/>
        </video>
    </div>
  </section>
</template>

<script>
import BigTitle from "@/components/shared/text/BigTitle.vue";
import MainTitle from "@/components/shared/text/MainTitle.vue";
import CardBanner from "@/components/entities/cards/CardBanner.vue";
import SliderBanner from "@/components/entities/SliderBanner.vue";
import MainButton from "@/components/shared/MainButton.vue";
import banners from "@/static/values/banners";
import {mapActions} from "vuex";

export default {
  name: "StartScreen",
  components: {MainButton, SliderBanner, CardBanner, MainTitle, BigTitle},
  mixins: [banners],
  data() {
    return {
      isLoading: true,
      btnText: 'Оставить заявку',
      visibleIndexItem: -1,
      mainTitle: 'Технологический партнер',
      mainParagraph: 'Интегратор автоматизированных производственных решений, а также производитель станочной и инструментальной оснастки AVEA BASIS. '
    }
  },
  mounted() {
    this.showNextItem();
  },
  methods: {
    ...mapActions(['IS_ACTIVE_MODAL']),
    load() {
      this.isLoading = false;
    },
    showNextItem() {
      if (this.visibleIndexItem < 2) {
        this.timer = setTimeout(() => {
          this.visibleIndexItem++
          this.showNextItem();
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .start-screen-container {
    position: relative;
    height: var(--calc-height);
    width: 100%;
    .bg-filter {
      bottom: 0;
      width: 100%;
      position: absolute;
      z-index: 1;
    }

    .start-screen-content {
      overflow: visible;
      position: relative;
      z-index: 2;
      height: 100%;

      .bg-filter-mobile {
        display: none;
      }


      .block-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
    }

    .bg-container {
      width: 100%;
      opacity: 0;
      transition: all .3s ease;
      & video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.active {
        opacity: 1;
      }
    }
  }

  @media (max-width: 3024px){
    .start-screen-container {
      display: flex;
      align-items: flex-end;
      .bg-filter {
        bottom: 120px;
        height: 400px;
        backdrop-filter: blur(30px);
      }
      .start-screen-content {
        padding-bottom: 168px;
        .block-container {
          max-width: 880px;
          row-gap: 24px;
          .main-paragraph-container {
            max-width: 783px;
          }
        }
      }
    }
  }


  @media (max-width: 1920px) {
    .start-screen-container {
      .bg-filter {
        bottom: 120px;
        height: 352px;
        backdrop-filter: blur(40px);
      }
      .start-screen-content {
        padding-bottom: 160px;
        .block-container {
          max-width: 730px;
          .main-paragraph-container {
            max-width: 635px;
          }
        }
      }
    }
  }
  @media (max-width: 1600px) {
    .start-screen-container {
      .bg-filter {
        bottom: 100px;
        height: 262px;
        backdrop-filter: blur(30px);
      }
      .start-screen-content {
        padding-bottom: 132px;
        .block-container {
          max-width: 680px;
          .big-title-container {
            font-size: 54px;
          }
          .main-paragraph-container {
            max-width: 635px;
          }
        }
      }
    }
  }
  @media (max-height: 800px) {
    .start-screen-container {
      .bg-filter {
        bottom: 100px;
        height: 206px;
        backdrop-filter: blur(30px);
      }
      .start-screen-content {
        padding-bottom: 124px;
        .block-container {
          max-width: 482px;
          .big-title-container {
            font-size: 36px;
          }
          .main-paragraph-container {
            max-width: inherit;
          }
        }
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .start-screen-container {
      .bg-filter {
        bottom: 100px;
        height: 262px;
        backdrop-filter: blur(30px);
      }
      .start-screen-content {
        padding-bottom: 100px;
        .block-container {
          max-width: 680px;
          .big-title-container {
            font-size: 54px;
          }
          .main-paragraph-container {
            max-width: 635px;
          }
        }
      }
    }
  }

  @media (max-width: 1133px) {
    .start-screen-container {
      .bg-filter {
        bottom: 100px;
        height: 206px;
        backdrop-filter: blur(30px);
      }
      .start-screen-content {
        padding-bottom: 100px;
        .block-container {
          max-width: 482px;
          .big-title-container {
            font-size: 36px;
          }
          .main-paragraph-container {
            max-width: inherit;
          }
        }
      }
    }
  }
  @media (max-width: 769px) {
    .start-screen-container {
      .bg-filter {
        display: none;
      }
      .start-screen-content {
        height: fit-content;
        flex-direction: column;
        justify-content: flex-end;
        row-gap: 40px;
        align-items: center;
        padding: 10px 16px;
        margin-bottom: 32px;
        & > * {
          z-index: 1;
        }
        .bg-filter-mobile {
          width: 100%;
          position: absolute;
          z-index: 0;
          display: block;
          bottom: 0;
          height: 100%;
          backdrop-filter: blur(8px);
        }
        .block-container {
          text-align: center;
          row-gap: 8px;
          max-width: 100%;
        }
      }
    }
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    .start-screen-container {
      .start-screen-content {
        padding: 10px 20px;
      }
    }
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .start-screen-container {
      .bg-filter {
        bottom: 160px;
        height: 713px;
        backdrop-filter: blur(50px);
      }
      .start-screen-content {
        padding-bottom: 240px;
        .block-container {
          max-width: 1656px;
          row-gap: 40px;

          .main-paragraph-container {
            max-width: 1380px;
          }
        }
      }
    }
  }

</style>